export function canonicalAutoAppyUrl(value) {
  try {
    const url = new URL(value);
    if (url.hostname === 'app.autoappy.com') url.hostname = 'autoappy.com';
    return url.toString().replace(/\/+$/, '');
  } catch { return 'https://autoappy.com'; }
}
const mainUrl = canonicalAutoAppyUrl((process.env.REACT_APP_AUTOAPPY_MAIN_URL || 'https://autoappy.com').trim());
export function autoAppyUrl(path) {
  return `${mainUrl}${path.startsWith('/') ? path : `/${path}`}`;
}
